<template>
	<div class="app" id="app">
		<router-view/>
	</div>
</template>
<script>
import {setCookie} from './plugins/utils'
import axios from "axios";
import request from "@/plugins/axios";

export default {
	created() {
		 // const token = "eyJ0eXAiOiJqd3QifQ.eyJzdWIiOiIxIiwiaXNzIjoiaHR0cDpcL1wvOiIsImV4cCI6MTc1MjI0NjcxMSwiaWF0IjoxNzUxNjQxOTExLCJuYmYiOjE3NTE2NDE5MTEsInVpZCI6MjYxLCJzIjoieFJmdW1rIiwianRpIjoiODRlZWIyMTBhY2I4MzM3OTk3N2NmNjU5ZmQzN2UzZWUifQ.JDJ5JDEwJERSTGRxM3Y0cmtyc0thNFo2b1N2R091TWRCTk1XRnJmVFYvdThWWERwZXV3VlNNVTV6M2k2"//"eyJ0eXAiOiJqd3QifQ.eyJzdWIiOiIxIiwiaXNzIjoiaHR0cDpcL1wvOiIsImV4cCI6MTc1MTYxMzAwOCwiaWF0IjoxNzUxMDA4MjA4LCJuYmYiOjE3NTEwMDgyMDgsInVpZCI6MjYxLCJzIjoiand4MmpkIiwianRpIjoiMTg4ZjkyZWJmYWE3OTg5NTQ4NzQyYzViZTM5MzBlMTUifQ.JDJ5JDEwJDQ2amVJVHR2aWU3czVmWndLbnRnQmVYOURZM1lWUjhPcmZ6a1RGcWdtb3pzdmNzVE1GeG55"
		 // setCookie('workbench_agentId', 7, 66666666 - 120)
		 // setCookie('workbench_token', token, 66666666 - 120)
	}
}
</script>
<style lang="less">
@import "./assets/css/style";

* {
	box-sizing: border-box !important;
}

body {
	background: #f7f7f7 !important;
}

.app {
	width: 100%;
	max-width: var(--base-px-800);
	background: #fff;
	border-radius: var(--base-px-8);
	margin: 0 auto;
	height: 100%;
}
</style>
